import React, { useState } from "react";

const LockApplication = () => {
  const [selectedOptions, setSelectedOptions] = useState({});
  const handleCheckboxChange = (category, option) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [option]: !prev[category]?.[option],
      },
    }));
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h2>Lock Application - </h2>

      <Section title="Event Type">
        {["Cricket", "Soccer", "Tennis", "Kabaddi", "Horse", "GreyHound"].map(
          (event) => (
            <Checkbox
              key={event}
              label={event}
              category="eventType"
              handleCheckboxChange={handleCheckboxChange}
              checked={selectedOptions?.eventType?.[event] || false}
            />
          )
        )}
      </Section>

      <Section title="Type">
        {[
          "All Odds",
          "Exch Bookmaker",
          "All Bookmaker",
          "Betfair Fancy",
          "Exch Fancy",
          "Other Fancy",
        ].map((type) => (
          <Checkbox
            key={type}
            label={type}
            category="type"
            handleCheckboxChange={handleCheckboxChange}
            checked={selectedOptions?.type?.[type] || false}
          />
        ))}
      </Section>

      <Section title="Market Type">
        <Category
          title="Cricket"
          options={[
            "Match Odds",
            "Bookmaker",
            "Special Maker",
            "Tournament Winner",
            "Tied Match",
            "Completed Match",
            "To Win the Toss",
            "1st Inning Runs",
            "1st Inning 6 Ovr Line",
            "1st Inning 10 Ovr Line",
            "1st Inning 15 Ovr Line",
            "1st Inning 20 Ovr Line",
            "2nd inning Runs",
            "2nd Inning 6 Ovr Line",
            "2nd Inning 10 Ovr Line",
            "2nd Inning 15 Ovr Line",
            "Over",
            "Batsman",
            "Single Over",
            "Odd Even",
            "Three Selection",
            "Ball By Ball",
            "Lottery",
          ]}
          category="cricket"
          handleCheckboxChange={handleCheckboxChange}
          selectedOptions={selectedOptions}
        />

        <Category
          title="Soccer"
          options={[
            "Match Odds",
            "Bookmaker",
            "Special Maker",
            "Over Under 05",
            "Over Under 15",
            "Over Under 25",
            "Over Under 35",
            "Lottery",
          ]}
          category="soccer"
          handleCheckboxChange={handleCheckboxChange}
          selectedOptions={selectedOptions}
        />

        <Category
          title="Tennis"
          options={[
            "Match Odds",
            "Set Winner",
            "Bookmaker",
            "Special Maker",
            "Lottery",
          ]}
          category="tennis"
          handleCheckboxChange={handleCheckboxChange}
          selectedOptions={selectedOptions}
        />
      </Section>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div style={{ marginBottom: "15px", position: "relative" }}>
    <strong style={{ fontSize: "17px" }}>{title}:</strong>
    <div
      style={
        title == "Market Type"
          ? {
              border: "1px solid #ccc",
              padding: "10px",
              marginTop: "5px",
              borderRadius: "5px",
            }
          : {
              border: "1px solid #ccc",
              padding: "10px",
              marginTop: "5px",
              borderRadius: "5px",
              display: "flex",
            }
      }
    >
      {children}
    </div>
  </div>
);

const Category = ({
  title,
  options,
  category,
  handleCheckboxChange,
  selectedOptions,
}) => (
  <div style={{ marginTop: "10px" }}>
    <strong style={{ fontSize: "17px", fontWeight: "700" }}>{title}</strong>
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "10px",
        marginTop: "5px",
      }}
    >
      {options.map((option) => (
        <Checkbox
          key={option}
          label={option}
          category={category}
          handleCheckboxChange={handleCheckboxChange}
          checked={selectedOptions?.[category]?.[option] || false}
        />
      ))}
    </div>
  </div>
);

const Checkbox = ({ label, category, handleCheckboxChange, checked }) => (
  <label
    style={{
      display: "flex",
      alignItems: "center",
      gap: "5px",
      fontSize: "14px",
      //   fontWeight: "600",
    }}
  >
    {label}
    <input
      style={{
        width: "15px",
        height: "15px",
        borderRadius: "0",
        border: "1px solid grey",
        marginRight: "10px",
        marginLeft: "4px",
      }}
      type="checkbox"
      checked={checked}
      onChange={() => handleCheckboxChange(category, label)}
    />
  </label>
);

export default LockApplication;


// convert this in same format as above

// convert this data into JSON array with key platform,gameType,gameCode,name